import axiosClient from '../axiosClient';

const shareAPI = {
    async createLinkShareAPI(data) {
        const url = `/link_share`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
    async clickOnLinkAPI(data) {
        const url = `/bonus/click_on_link`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
};

export default shareAPI;
